import React, { FC, useEffect, useState } from "react";
import PreAuthClaim from "../../../components/patient/PreAuthClaim/PreAuthClaim";
import { IUploadReferral } from "../../../interfaces/IReferral";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  fetchProcedure,
  fetchProcedureList,
  fetchSchemeById,
  getClaimSubmission,
  resetLocalFiles,
  saveChanges,
  setUploadedDocumentUrl,
  setWizardSteps,
  submitClaimSubmission,
  submitClaimSubmissionToEdgePro,
  toggleEditMode,
  updateClaimDataField,
  updateClaimSubmission,
  updateField,
  updateWizardStep,
  UploadDocument,
  uploadPreAuthClaimDoc,
} from "../../../models/preAuthClaimSlice";
import { IDocumentFields } from "../../../interfaces/ICase";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import {
  PreAuthClaimField,
  PreAuthClaimResponse,
  PreAuthClaimSection,
} from "../../../interfaces/IPreAuthClaim";
import { message } from "antd";
import FilePreviewModal from "../../../components/patient/PreAuth-query/FilePreviewModal";
import { getPortalData, resetPortalData } from "../../../models/preAuthSlice";
import dayjs from "dayjs";
import RightSidePreviewModal from "../../../components/modals/RightSidePreviewModal";
import {
  deleteUploadedDocument,
  downloadDocument,
  fetchEnhancementProcedure,
  submitApproval,
} from "../../../apis/patientService";
import {
  clearDeficiencyCheck,
  getDeficiencyQuestionData,
  getDeficiencyQuestions,
} from "../../../models/patientSlice";
import DocumentDeficiencyModal from "../../../components/patient/DocumentDeficiencyModal";
import Loader from "../../../utils/Spinners";
import { useLocation } from "react-router-dom";

type PreAuthClaimContainerProps = {
  claimId: string | null;
  onfetchStepper: () => void; // Define prop type for the function
  stepperForStatus: CallableFunction;
  nextStage: any;
  setMoveToNext: CallableFunction;
  isScreen: string;
};

const PreAuthClaimContainer: FC<PreAuthClaimContainerProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false); //to open a modal of preview
  const { patients, auth, hospital, preAuthClaim, preAuth } = useSelector(
    (state: RootState) => state
  );
  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [newClaimId, setNewClaimId] = useState<string | null>(null);
  const [portalSubmission, setPortalSubmission] = useState<string | null>(null);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [caseClaimSubmissionId, setCaseClaimSubmissionId] = useState<
    number | null
  >(null);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null
  ); //to send document id for deficiency check
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);

  const location = useLocation();
  const path = location.pathname;
  const visitId = path.split("/")[3];
  const [totalAmount, setTotalAmount] = useState<any>(0);
  const [cghsProcedures, setCghsProcedures] = useState<any>([]);
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] =
    useState<string>("");

  const handleFetchProcedureList = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const res = await fetchEnhancementProcedure(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        setCghsProcedures(res);
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  useEffect(() => {
    handleFetchProcedureList();
  }, []);

  // useEffect(() => {
  //   const fetchDeficiencyData = async () => {
  //     try {
  //       if (selectedDocumentId) {
  //         const res = await dispatch(
  //           getDeficiencyQuestions(selectedDocumentId)
  //         );
  //       }
  //     } catch (err) {
  //       errorMessage("Please, Try again after sometime");
  //       setSelectedDocumentId(null);
  //       setSelectedDocument(null);
  //     }
  //   };

  //   if (selectedDocumentId) fetchDeficiencyData();
  // }, [selectedDocumentId]);

  // useEffect(() => {
  //   const fetchDeficiencyData = async () => {
  //     try {
  //       if (selectedDocument?.id) {
  //         const res = await dispatch(
  //           getDeficiencyQuestionData(selectedDocument?.id)
  //         );
  //       }
  //       // if(true) {
  //       //   const res = await dispatch(getDeficiencyQuestions(874));
  //       // }
  //     } catch (err) {
  //       errorMessage("Please, Try again after sometime");
  //       setSelectedDocumentId(null);
  //       setSelectedDocument(null);
  //     }
  //   };
  //   if (selectedDocument?.id) fetchDeficiencyData();
  // }, [selectedDocument]);

  useEffect(() => {
    if (cghsProcedures && cghsProcedures?.length > 0) {
      const total = cghsProcedures?.reduce((sum: any, procedure: any) => {
        const amount = procedure?.procedureName
          ?.toLowerCase()
          ?.includes("unspecified")
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
      // Update the state with the calculated total amount
      setTotalAmount(total);
      // dispatch(cghsAction.totalAmountOfProcedures(total));
    }
  }, [cghsProcedures]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedDocumentId) {
          dispatch(clearDeficiencyCheck());
          // const firstRes = await dispatch(
          //   getDeficiencyQuestions(selectedDocumentId)
          // );

          if (selectedDocument?.id) {
            const secondRes = await dispatch(
              getDeficiencyQuestionData(selectedDocument?.id)
            );
          }
        }
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setSelectedDocumentId(null);
        setSelectedDocument(null);
      }
    };

    if (selectedDocumentId || selectedDocument?.id) fetchData();
  }, [selectedDocumentId, selectedDocument?.id]);

  const handleDeficiencyModalOpen = (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalAfterSave = (
    documentUrl: string,
    documentId: number,
    field: any
  ) => {
    const document = {
      id: field?.documentId,
      documentName: field?.documentName,
      documentType: field?.labelId,
      documentUrl: field?.data,
      documentLabelType: field?.label,
      deficiencyCheckStatus: field?.deficiencyCheckStatus,
    };
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  const handleFileChange =
    (documentType: string, docLabel: string | null = null) =>
    (e: any) => {
      const maxSize = 15 * 1024 * 1024;
      if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
        if (Array.isArray(e)) {
          return e;
        }
        // if (e?.file?.size > maxSize) {
        //   errorMessage("File Limit must be less than or equal to 15 MB");
        //   return;
        // }
        if (
          docLabel &&
          (docLabel?.toUpperCase() === "CASE SHEET" ||
            docLabel?.toUpperCase() ===
              "Implant Bill Attachments"?.toUpperCase()) &&
          e?.fileList[0]?.type !== "application/pdf"
        ) {
          errorMessage("File Must be PDF only");
          return;
        }
        if (e?.fileList[0]) {
          setSelectedFile({ file: e?.fileList[0], documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setUploadFileModal(true);
        }
        return e?.fileList;
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        // if (e?.file?.size > maxSize) {
        //   errorMessage("File Limit must be less than or equal to 15 MB");
        //   return;
        // }
        if (e?.fileList[0]) {
          setSelectedFile({ file: e?.fileList[0], documentType });
          setPreviewFile({
            url: URL.createObjectURL(e?.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setUploadFileModal(true);
        }
        return e?.fileList;
      }
    };

  const handleCancel = () => {
    setUploadFileModal(false);
  };

  const viewFile = (file: any) => {
    window.open(file, "_blank");
  };

  const handleEditable = () => {
    if (!isEditable && preAuthClaim && preAuthClaim?.preAuthClaimRes) {
      const preAuthClaimRes = preAuthClaim.preAuthClaimRes;

      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(preAuthClaim?.preAuthClaimRes)?.forEach((key) => {
        const sections = preAuthClaimRes[key as keyof PreAuthClaimResponse] as
          | PreAuthClaimSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array?.isArray(fields)) {
                fields?.forEach((field: PreAuthClaimField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }

                  if (
                    preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse
                  ) {
                    initialEditedFields[key][field?.id] = field?.id
                      ?.toLowerCase()
                      ?.includes("date")
                      ? field?.data
                        ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
                        : null
                      : initialEditedFields[key]?.[field?.id] && !field?.data
                      ? initialEditedFields[key][field?.id]
                      : field.data ?? null;

                    // initialEditedFields[key][field?.id] = field?.id
                    //   ?.toLowerCase()
                    //   ?.includes("date")
                    //   ? field?.data
                    //     ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
                    //     : null
                    //   : field.data ?? null;
                  } else if (
                    preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
                  ) {
                    initialEditedFields[key][field?.id] = field?.data ?? "";
                  } else if (
                    preAuthClaim?.preAuthClaimRes
                      ?.starHealthClaimSubmissionResponse
                  ) {
                    initialEditedFields[key][field.id] = field?.id
                      ?.toLowerCase()
                      ?.includes("date")
                      ? field?.data
                        ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
                        : null
                      : field.data ?? null;
                  }
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    }
    setIsEditable(!isEditable);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };

  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  const handleOpen = () => {
    setPreviewDocument(true);
  };

  const getAttachmentsWithValues = (preAuthClaimData: PreAuthClaimResponse) => {
    const attachmentsWithValues: Array<IDocumentFields> = [];

    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType &&
      preAuthClaimData?.cghsClaimSubmissionResponse
    ) {
      const attachments = preAuthClaimData?.cghsClaimSubmissionResponse?.[0]?.[
        patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase()
      ]?.filter(
        (doc) =>
          doc?.type === "document-upload" || doc?.type === "document-show"
      );
      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
        // if (attachment?.data && attachment?.documentName) {
        //   attachmentsWithValues.push({
        //     documentName: attachment?.documentName,
        //     documentType: attachment?.labelId,
        //     documentUrl: attachment?.data,
        //     documentLabelType: attachment?.label,
        //     id: attachment?.documentId,
        //     deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
        //     prefilledData: true,
        //   });
        // }
      });

      dispatch(setUploadedDocumentUrl(attachmentsWithValues));
    } else if (preAuthClaimData?.starHealthClaimSubmissionResponse) {
      const attachments =
        preAuthClaimData?.starHealthClaimSubmissionResponse?.[0]?.[
          "document"
        ]?.filter(
          (doc) =>
            doc?.type === "document-upload" || doc?.type === "document-show"
        );
      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });

      dispatch(setUploadedDocumentUrl(attachmentsWithValues));
    }
  };

  // const getAttachmentsWithValues = (preAuthClaimData: PreAuthClaimResponse) => {
  //   const attachmentsWithValues: Array<IDocumentFields> = [];

  //   if (
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType &&
  //     preAuthClaimData?.cghsClaimSubmissionResponse
  //   ) {
  //     const attachments = preAuthClaimData?.cghsClaimSubmissionResponse?.[0]?.[
  //       patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase()
  //     ]?.filter(
  //       (doc) =>
  //         doc?.type === "document-upload" || doc?.type === "document-show"
  //     );
  //     attachments?.forEach((attachment) => {
  //       if (attachment?.data && attachment?.documentName) {
  //         attachmentsWithValues.push({
  //           documentName: attachment?.documentName,
  //           documentType: attachment?.labelId,
  //           documentUrl: attachment?.data,
  //           documentLabelType: attachment?.label,
  //           id: attachment?.documentId,
  //           deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
  //           prefilledData: true,
  //         });
  //       }
  //     });

  //     dispatch(setUploadedDocumentUrl(attachmentsWithValues));
  //   } else if (preAuthClaimData?.starHealthClaimSubmissionResponse) {
  //     const attachments =
  //       preAuthClaimData?.starHealthClaimSubmissionResponse?.[0]?.[
  //         "document"
  //       ]?.filter(
  //         (doc) =>
  //           doc?.type === "document-upload" || doc?.type === "document-show"
  //       );
  //     attachments?.forEach((attachment) => {
  //       if (attachment?.data && attachment?.documentName) {
  //         attachmentsWithValues.push({
  //           documentName: attachment?.documentName,
  //           documentType: attachment?.labelId,
  //           documentUrl: attachment?.data,
  //           documentLabelType: attachment?.label,
  //           id: attachment?.documentId,
  //           deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
  //         });
  //       }
  //     });

  //     dispatch(setUploadedDocumentUrl(attachmentsWithValues));
  //   }
  // };

  useEffect(() => {
    dispatch(setUploadedDocumentUrl([]));
  }, []);

  useEffect(() => {
    if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
      preAuthClaim?.uploadedDocumentUrl?.forEach((doc) =>
        dispatch(
          updateField({
            sectionKey: "cghsClaimSubmissionResponse",
            fieldId: doc?.documentLabelType?.split(" ").join("_"),
            value: doc?.documentUrl,
          })
        )
      );
    } else if (
      preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
    ) {
      preAuthClaim?.uploadedDocumentUrl?.forEach((doc) =>
        dispatch(
          updateField({
            sectionKey: "starHealthClaimSubmissionResponse",
            fieldId: doc?.documentLabelType?.split(" ").join("_"),
            value: doc?.documentUrl,
          })
        )
      );
    }
  }, [preAuthClaim?.uploadedDocumentUrl]);

  useEffect(() => {
    if (preAuthClaim && preAuthClaim?.preAuthClaimRes) {
      const preAuthClaimRes = preAuthClaim?.preAuthClaimRes;
      const initialEditedFields: Record<string, Record<string, string>> = {};
      Object?.keys(preAuthClaimRes)?.forEach((key) => {
        const sections = preAuthClaimRes[key as keyof PreAuthClaimResponse] as
          | PreAuthClaimSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object?.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array?.isArray(fields)) {
                fields?.forEach((field: PreAuthClaimField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }
                  // if(!initialEditedFields[key][field?.id] && field?.type != "document-upload") initialEditedFields[key][field?.id] = field?.data ?? "";
                  initialEditedFields[key][field?.id] =
                    initialEditedFields[key]?.[field?.id] && !field?.data
                      ? initialEditedFields[key][field?.id]
                      : field.data ?? "";
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    } else if (caseClaimSubmissionId) {
      setIsEditable(false);
    }
  }, [caseClaimSubmissionId, preAuthClaim?.preAuthClaimRes]);

  // const handleDeleteList = async (docType: string, idx: number) => {
  //   const deleteDocument = preAuthClaim?.uploadedDocumentUrl?.find((_, index) => index === idx);
  //   const deleteForm = {
  //     documentUrl: deleteDocument?.documentUrl,
  //     status: false
  //   }
  //   const newUpdatedDocumentList = preAuthClaim?.uploadedDocumentUrl?.filter(
  //     (docs, index) => index !== idx
  //   );
  //   dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
  //   if(deleteDocument?.documentUrl) {
  //     await deleteUploadedDocument(deleteForm);
  //   }
  //   if (docType?.toUpperCase() === "BILL ATTACHMENTS") {
  //     const hasBillDocument = preAuthClaim?.uploadedDocumentUrl?.some(
  //       (doc) => doc?.documentType?.toUpperCase() === "BILL ATTACHMENTS"
  //     );
  //     if (hasBillDocument) {
  //       dispatch(
  //         updateField({
  //           sectionKey: "cghsClaimSubmissionResponse",
  //           fieldId: docType?.split(" ").join("_"),
  //           value: "",
  //         })
  //       );
  //     }
  //   } else {
  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsClaimSubmissionResponse",
  //         fieldId: docType?.split(" ").join("_"),
  //         value: "",
  //       })
  //     );
  //   }
  // };

  // const handleDeleteList = async (docType: string, documentUrl: string, idx: number) => {
  //   const deleteDocument = preAuthClaim?.uploadedDocumentUrl?.find((doc, index) => doc?.documentUrl === documentUrl);
  //   const deleteForm = {
  //     documentUrl: deleteDocument?.documentUrl,
  //     status: false
  //   }
  //   const newUpdatedDocumentList = preAuthClaim?.uploadedDocumentUrl?.filter(
  //     (doc, index) => doc?.documentUrl !== documentUrl
  //   );
  //   dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
  //   if(deleteDocument?.documentUrl) {
  //     await deleteUploadedDocument(deleteForm);
  //   }
  //   if (docType?.toUpperCase() === "BILL ATTACHMENTS" || docType?.toUpperCase() === "INVESTIGATION REPORTS" || docType?.toUpperCase() === "CGHS BILL" ||
  //   docType?.toUpperCase() === "CONSULTATION NOTES") {
  //     const hasDocument = preAuthClaim?.uploadedDocumentUrl?.some(
  //       (doc) => doc?.documentType?.toUpperCase() === docType?.toUpperCase()
  //     );
  //     if (!hasDocument) {
  //       dispatch(
  //         updateField({
  //           sectionKey: "cghsClaimSubmissionResponse",
  //           fieldId: docType?.split(" ").join("_"),
  //           value: "",
  //         })
  //       );
  //     }
  //   } else {
  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsClaimSubmissionResponse",
  //         fieldId: docType?.split(" ").join("_"),
  //         value: "",
  //       })
  //     );
  //   }
  // };

  const handleDeleteList = async (
    docType: string,
    documentUrl: string,
    idx: number
  ) => {
    const deleteDocument = preAuthClaim?.uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = preAuthClaim?.uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );
    dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
    if (deleteDocument?.documentUrl) {
      const res = await deleteUploadedDocument(deleteForm);

      if (res) {
        if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
          if (
            docType?.toUpperCase() === "BILL ATTACHMENTS" ||
            docType?.toUpperCase() === "INVESTIGATION REPORTS" ||
            docType?.toUpperCase() === "CGHS BILL" ||
            docType?.toUpperCase() === "CONSULTATION NOTES" ||
            docType?.toUpperCase() === "CASE SHEET" ||
            docType?.toUpperCase() === "CONSUMABLE DOCUMENT" ||
            docType?.toUpperCase() === "DRUG CERTIFICATE" ||
            docType?.toUpperCase() ===
              "Implant Bill Attachments"?.toUpperCase() ||
            docType?.toUpperCase() === "IMPLANT INVOICE"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Justification for unspecified package"?.toUpperCase() ||
            docType?.toUpperCase() === "PROCEDURE NOTES"?.toUpperCase() ||
            docType?.toUpperCase() === "Post Procedure X Ray"?.toUpperCase() ||
            docType?.toUpperCase() === "CLINICAL NOTES"?.toUpperCase() ||
            docType?.toUpperCase() === "AUDITED BILL"
          ) {
            const hasDocument = newUpdatedDocumentList?.some(
              (doc) =>
                doc?.documentLabelType?.toUpperCase() === docType?.toUpperCase()
            );
            if (!hasDocument) {
              dispatch(
                updateField({
                  sectionKey: "cghsClaimSubmissionResponse",
                  fieldId: docType?.split(" ").join("_"),
                  value: "",
                })
              );
            }
          } else {
            dispatch(
              updateField({
                sectionKey: "cghsClaimSubmissionResponse",
                fieldId: docType?.split(" ").join("_"),
                value: "",
              })
            );
          }
          dispatch(
            updateClaimDataField({
              sectionKey: "cghsClaimSubmissionResponse",
              fieldId: docType?.split(" ").join("_"),
              visitType:
                patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase(),
              updateValues: {
                data: "",
                documentName: "",
              },
              documentUrl: deleteDocument?.documentUrl,
            })
          );
        } else if (
          preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
        ) {
          if (
            docType?.toUpperCase() === "DISCHARGE SUMMARY" ||
            docType?.toUpperCase() === "INVESTIGATION REPORTS" ||
            docType?.toUpperCase() === "Operation Notes"?.toUpperCase() ||
            docType?.toUpperCase() === "Indoor Case papers"?.toUpperCase() ||
            docType?.toUpperCase() === "Medicine Bills"?.toUpperCase() ||
            docType?.toUpperCase() === "OTHERS"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Investigation Reports-Films"?.toUpperCase()
          ) {
            const hasDocument = newUpdatedDocumentList?.some(
              (doc) =>
                doc?.documentLabelType?.toUpperCase() === docType?.toUpperCase()
            );
            if (!hasDocument) {
              dispatch(
                updateField({
                  sectionKey: "starHealthClaimSubmissionResponse",
                  fieldId: docType?.split(" ").join("_"),
                  value: "",
                })
              );
            }
          } else {
            dispatch(
              updateField({
                sectionKey: "starHealthClaimSubmissionResponse",
                fieldId: docType?.split(" ").join("_"),
                value: "",
              })
            );
          }
          dispatch(
            updateClaimDataField({
              sectionKey: "starHealthClaimSubmissionResponse",
              fieldId: docType?.split(" ").join("_"),
              visitType: "document",
              updateValues: {
                data: "",
                documentName: "",
              },
              documentUrl: deleteDocument?.documentUrl,
            })
          );
        }
        // getClaimSubmissionData();
      }
    }
  };

  // useEffect(() => {
  //   if (preAuthClaim?.preAuthClaimRes) {
  //     getAttachmentsWithValues(preAuthClaim?.preAuthClaimRes);
  //   }
  // }, [preAuthClaim?.preAuthClaimRes]);

  const getClaimSubmissionData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      (patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds ||
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList)
    ) {
      const resp = await dispatch(
        getClaimSubmission({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          portalId:
            patients?.fetchBasicDetails?.casesResponse
              ?.portalMetaDataIds?.[0] ||
            preAuthClaim?.selectedScheme?.portalMetaDataIdsList?.[0],
        })
      );

      if (getClaimSubmission.fulfilled.match(resp)) {
        if (resp?.payload?.claimSubmissionRes) {
          getAttachmentsWithValues(resp?.payload?.claimSubmissionRes);
        }
        dispatch(
          setWizardSteps([
            {
              step: 0,
              title: "PROCEDURE DETAILS",
              canNavigate: true,
              completed: true,
            },
            {
              step: 1,
              title: "CLAIM DETAILS",
              canNavigate: false,
              completed: false,
            },
          ])
        );
      }
      if (getClaimSubmission.rejected.match(resp)) {
        errorMessage(resp?.error?.message || "Please, Try again later");
      }
    }
  };

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.id === parseInt(visitId)
    ) {
      getClaimSubmissionData();
      props?.stepperForStatus();
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    preAuthClaim?.selectedScheme?.portalMetaDataIdsList,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    patients?.fetchBasicDetails,
    visitId,
  ]);

  useEffect(() => {
    if (
      preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse &&
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType
    ) {
      // Update caseClaimSubmissionId with the new value
      const newCaseClaimSubmissionId =
        preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse[0]?.[
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase()
        ]?.[0]?.caseClaimSubmissionId;

      const portalSubmitCheck =
        preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse[0]?.[
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase()
        ]?.[0]?.status;
      if (portalSubmitCheck !== undefined) {
        setPortalSubmission(portalSubmitCheck);
      }
      if (newCaseClaimSubmissionId) {
        setCaseClaimSubmissionId(newCaseClaimSubmissionId);
      } else {
        setCaseClaimSubmissionId(null);
      }
    } else if (
      preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
    ) {
      // Update caseClaimSubmissionId with the new value
      const newCaseClaimSubmissionId =
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse?.[0]?.[
          "document"
        ]?.[0]?.caseClaimSubmissionId;

      const portalSubmitCheck =
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse?.[0]?.[
          "document"
        ]?.[0]?.status;
      if (portalSubmitCheck !== undefined) {
        setPortalSubmission(portalSubmitCheck);
      }

      if (newCaseClaimSubmissionId) {
        setCaseClaimSubmissionId(newCaseClaimSubmissionId);
        // dispatch(
        //   setUploadedDocumentUrl(
        //     preAuthClaim?.preAuthClaimRes
        //       ?.starHealthClaimSubmissionResponse?.[0]?.["document"]
        //   )
        // );
      } else {
        setCaseClaimSubmissionId(null);
        // dispatch(
        //   setUploadedDocumentUrl(
        //     preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
        //   )
        // );
      }
    } else {
      setCaseClaimSubmissionId(123);
    }
  }, [preAuthClaim?.preAuthClaimRes, portalSubmission]);

  useEffect(() => {
    if (!props?.claimId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        dispatch(
          getPortalData({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      } else {
        dispatch(resetPortalData());
      }
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    if (!props?.claimId) {
      if (preAuth?.portalData) {
        const {
          casePreAuthEchs,
          casePreAuthIhx,
          casePreAuthCghs,
          casePreAuthStarhealth,
        } = preAuth.portalData;

        if (casePreAuthEchs?.casePreAuthEchsReferralResponse) {
          setNewClaimId(
            casePreAuthEchs.casePreAuthEchsReferralResponse.claimId || null
          );
        } else if (casePreAuthEchs?.casePreAuthEchsEmergencyResponse) {
          setNewClaimId(
            casePreAuthEchs.casePreAuthEchsEmergencyResponse.claimId || null
          );
        } else if (casePreAuthIhx) {
          setNewClaimId(casePreAuthIhx.claimId || null);
        } else if (casePreAuthCghs) {
          setNewClaimId(casePreAuthCghs.claimId || null);
        } else if (casePreAuthStarhealth) {
          setNewClaimId(casePreAuthStarhealth.claimId || null);
        } else {
          setNewClaimId(null);
        }
      } else {
        setNewClaimId(null);
      }
    }
  }, [preAuth?.portalData]);

  // const updateOrAddDocument = (
  //   uploadedDocumentUrl: Array<IDocumentFields>,
  //   documentRes: IDocumentFields
  // ): Array<IDocumentFields> => {
  //   const updatedDocuments = [...uploadedDocumentUrl];
  //   const documentIndex = updatedDocuments.findIndex(
  //     (doc) => doc.documentType === documentRes.documentType
  //   );

  //   if (
  //     documentIndex !== -1 &&
  //     documentRes?.documentType?.toUpperCase() !== "BILL ATTACHMENTS"
  //   ) {
  //     updatedDocuments[documentIndex] = {
  //       ...updatedDocuments[documentIndex],
  //       documentName: documentRes.documentName,
  //       documentUrl: documentRes.documentUrl,
  //     };
  //   } else {
  //     updatedDocuments.push({
  //       documentType: documentRes.documentType,
  //       documentName: documentRes.documentName,
  //       documentUrl: documentRes.documentUrl,
  //     });
  //   }
  //   return updatedDocuments;
  // };

  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    const updatedDocuments = [...uploadedDocumentUrl];
    const documentIndex = updatedDocuments.findIndex(
      (doc) => doc.documentType === documentRes.documentType
    );

    if (
      documentIndex !== -1 &&
      preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse &&
      documentRes?.documentLabelType?.toUpperCase() !== "BILL ATTACHMENTS" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "INVESTIGATION REPORTS" &&
      documentRes?.documentLabelType?.toUpperCase() !== "CGHS BILL" &&
      documentRes?.documentLabelType?.toUpperCase() !== "CONSULTATION NOTES" &&
      documentRes?.documentLabelType?.toUpperCase() !== "CASE SHEET" &&
      documentRes?.documentLabelType?.toUpperCase() !== "CONSUMABLE DOCUMENT" &&
      documentRes?.documentLabelType?.toUpperCase() !== "DRUG CERTIFICATE" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Implant Bill Attachments"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "IMPLANT INVOICE"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Justification for unspecified package"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "PROCEDURE NOTES"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Post Procedure X Ray"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "CLINICAL NOTES"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !== "AUDITED BILL"
    ) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      };
    } else if (
      documentIndex !== -1 &&
      preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse &&
      documentRes?.documentLabelType?.toUpperCase() !== "DISCHARGE SUMMARY" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "INVESTIGATION REPORTS" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Operation Notes"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Indoor Case papers"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Medicine Bills"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "OTHERS"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Investigation Reports-Films"?.toUpperCase()
    ) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      };
    } else {
      updatedDocuments.push({
        documentType: documentRes.documentType,
        documentName: documentRes.documentName,
        documentUrl: documentRes.documentUrl,
        documentLabelType: documentRes?.documentLabelType,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      });
    }
    return updatedDocuments;
  };

  const handleUploadDocument = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file?.originFileObj as Blob);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      );
      if (UploadDocument.fulfilled.match(resp)) {
        const updatedDocuments = updateOrAddDocument(
          preAuthClaim?.uploadedDocumentUrl,
          resp?.payload
        );
        if (resp?.payload?.documentUrl) {
          message.success(
            `${resp?.payload?.documentLabelType} uploaded successfully`
          );
          dispatch(setUploadedDocumentUrl(updatedDocuments));
        } else {
          message.error("Please Upload Again");
        }
        setUploadFileModal(false);
      } else if (UploadDocument.rejected.match(resp)) {
        errorMessage("FAILED TO UPLOAD DOCUMENT");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleFieldChange = (
    sectionKey: string,
    fieldId: string,
    value: string
  ) => {
    if (fieldId?.toLowerCase()?.includes("date")) {
      dispatch(
        updateField({
          sectionKey,
          fieldId,
          value: dayjs(value, "DD-MM-YYYY HH:mm:ss"),
        })
      );
    } else {
      dispatch(updateField({ sectionKey, fieldId, value }));
    }
  };

  const handleSaveChanges = async () => {
    setIsSubmitted(true);
    try {
      let dataToSave: any = {};

      if (
        preAuthClaim?.preAuthClaimRes &&
        preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
      ) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (
                fieldId === "DateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave.dateOfDischarge = value === "" ? null : value;
              } else {
                dataToSave[fieldId] =
                  value === "true" ? true : value === "false" ? false : value;
              }
            });
          }
        );

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }
      } else if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        dataToSave["totalAmount"] = totalAmount?.toString() || null;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        dataToSave["totalAmount"] = totalAmount?.toString() || null;

        if (!props?.claimId && !newClaimId) {
          errorMessage("Claim Id is not present");
          return;
        }
      } else if (
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
      ) {
        // Add ihxClaimSubmissionResponses to documents
        // dataToSave = {
        //   ...dataToSave,
        //   additionalAmountPaid: false,
        //   claimNo: props?.claimId || newClaimId || "12132",
        //   status: true,
        //   ...preAuthClaim.editedFields.starHealthClaimSubmissionResponse,
        // };
        // delete dataToSave.document;
        // // Add uploadedDocumentUrl to documents if it exists

        // if (caseClaimSubmissionId) {
        //   const formattedDocuments = preAuthClaim?.uploadedDocumentUrl?.map(
        //     (doc: any) => ({
        //       documentType: doc?.documentType,
        //       documentName: doc.id,
        //       documentUrl: doc.data || doc.documentUrl,
        //     })
        //   );

        //   if (preAuthClaim?.uploadedDocumentUrl) {
        //     dataToSave.documents = [...formattedDocuments];
        //   }
        // } else {
        //   if (preAuthClaim?.uploadedDocumentUrl) {
        //     dataToSave.documents = [
        //       ...(dataToSave.documents || []),
        //       ...preAuthClaim.uploadedDocumentUrl.slice(1),
        //     ];
        //   }
        // }

        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      }

      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList
      ) {
        if (!caseClaimSubmissionId) {
          const resp = await dispatch(
            submitClaimSubmission({
              data: {
                ...dataToSave,
                hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
                schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
              },
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
            })
          );

          if (submitClaimSubmission.fulfilled.match(resp)) {
            if (resp?.payload?.errorMessage) {
              errorMessage(resp?.payload?.errorMessage);
            } else {
              successMessage("CLAIM SUBMITTED SUCCESSFULLY");
              props?.onfetchStepper();
              dispatch(resetLocalFiles());
              getClaimSubmissionData();
            }
          } else if (submitClaimSubmission.rejected.match(resp)) {
            errorMessage("CLAIM HAS NOT BEEN SAVED, PLEASE, TRY AGAIN");
            dispatch(resetLocalFiles());
          }
        } else {
          const resp = await dispatch(
            updateClaimSubmission({
              data: {
                ...dataToSave,
                hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
                schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
              },
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
              caseClaimSubmissionId: caseClaimSubmissionId,
            })
          );

          if (updateClaimSubmission.fulfilled.match(resp)) {
            if (resp?.payload?.errorMessage) {
              errorMessage(resp?.payload?.errorMessage);
            } else {
              successMessage("CLAIM UPDATED SUCCESSFULLY");
              props?.onfetchStepper();
              dispatch(resetLocalFiles());
              getClaimSubmissionData();
            }
          } else if (updateClaimSubmission.rejected.match(resp)) {
            if (resp?.error?.message) {
              errorMessage(resp?.error?.message);
              dispatch(resetLocalFiles());
            }
          }
        }
      }
      dispatch(saveChanges());
      dispatch(setUploadedDocumentUrl([]));

      // message.success("Changes saved successfully");
    } catch (error: any) {
      if (
        error?.response?.status === 422 &&
        error?.response?.data?.toLowerCase()?.includes("submitted on portal")
      ) {
        message.error("Case Claim submitted on portal we can't update it.");
        // dispatch(toggleEditMode());
        setIsEditable(!isEditable);
        setIsSubmitted(false);
      } else {
        console.error("Failed to save changes:", error);
        message.error("Failed to save changes. Please try again.");
        setIsSubmitted(false);
      }
    }
  };
  const handleSaveChangeToEdgePro = async () => {
    setIsSubmitted(true);
    try {
      let dataToSave: any = {};

      if (
        preAuthClaim?.preAuthClaimRes &&
        preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
      ) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (
                fieldId === "DateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave.dateOfDischarge = value === "" ? null : value;
              } else {
                dataToSave[fieldId] =
                  value === "true" ? true : value === "false" ? false : value;
              }
            });
          }
        );

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }
      } else if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        dataToSave["totalAmount"] = totalAmount?.toString() || null;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      } else if (
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
      ) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      }

      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList
      ) {
        const resp = await dispatch(
          submitClaimSubmissionToEdgePro({
            data: {
              ...dataToSave,
              hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
              schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
            },
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
            caseClaimId: caseClaimSubmissionId || null, //caseClaimSubmissionId
          })
        );

        if (submitClaimSubmissionToEdgePro.fulfilled.match(resp)) {
          if (resp?.payload?.errorMessage) {
            errorMessage(resp?.payload?.errorMessage);
          } else {
            successMessage("CLAIM SAVED SUCCESSFULLY");
            props?.onfetchStepper();
            dispatch(resetLocalFiles());
            getClaimSubmissionData();
            dispatch(toggleEditMode);
          }
        } else if (submitClaimSubmissionToEdgePro.rejected.match(resp)) {
          errorMessage("CLAIM HAS NOT BEEN SAVED, PLEASE, TRY AGAIN");
          dispatch(resetLocalFiles());
        }
      }
      dispatch(saveChanges());
      dispatch(setUploadedDocumentUrl([]));

      // message.success("Changes saved successfully");
    } catch (error: any) {
      if (
        error?.response?.status === 422 &&
        error?.response?.data?.toLowerCase()?.includes("submitted on portal")
      ) {
        message.error("Case Claim submitted on portal we can't update it.");
        // dispatch(toggleEditMode());
        setIsEditable(!isEditable);
        setIsSubmitted(false);
      } else {
        console.error("Failed to save changes:", error);
        message.error("Failed to save changes. Please try again.");
        setIsSubmitted(false);
      }
    }
  };

  const handleSaveChangesIhx = async () => {
    let dataToSave: any = {};

    // Initialize documents array
    dataToSave.documents = [];

    // Add uploadedDocumentUrl to documents if it exists
    if (preAuthClaim?.uploadedDocumentUrl) {
      dataToSave.documents = [...preAuthClaim?.uploadedDocumentUrl];
    }

    // Check if ihxClaimSubmissionResponses exists and is an array
    if (preAuthClaim?.editedFields?.ihxClaimSubmissionResponses) {
      // Add ihxClaimSubmissionResponses to documents
      dataToSave = {
        ...dataToSave,
        claimId: props?.claimId || newClaimId,
        status: true,
        ...preAuthClaim.editedFields.ihxClaimSubmissionResponses,
      };
      dataToSave = {
        ...dataToSave,
      };
    }

    if (!props?.claimId && !newClaimId) {
      errorMessage("Claim Id is not present");
      return;
    }

    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList
      ) {
        const resp = await dispatch(
          submitClaimSubmission({
            data: {
              ...dataToSave,
              hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
              schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
            },
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
          })
        );

        if (submitClaimSubmission.fulfilled.match(resp)) {
          if (resp?.payload?.errorMessage) {
            errorMessage(resp?.payload?.errorMessage);
          } else {
            successMessage("CLAIM HAS BEEN SAVED SUCCESSFULLY");
            props?.onfetchStepper();
            dispatch(resetLocalFiles());
            getClaimSubmissionData();
          }
        } else if (submitClaimSubmission.rejected.match(resp)) {
          errorMessage("CLAIM HAS NOT BEEN SAVED, PLEASE, TRY AGAIN");
          dispatch(resetLocalFiles());
        }
      }
      dispatch(saveChanges());
      //   dispatch(clearUploadedDocumentUrlsAfterSave());
    } catch (error) {
      console.error("Failed to save changes:", error);
      message.error("Failed to save changes. Please try again.");
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      dispatch(
        fetchSchemeById(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        )
      );
    }
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CGHS" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CAPF")
    ) {
      dispatch(
        fetchProcedureList({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
      if (
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
        patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName &&
        patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        dispatch(
          fetchProcedure({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          })
        );
      }
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
  ]);

  const handleTabsChange = (activeStep: string) => {
    dispatch(updateWizardStep(parseInt(activeStep)));
  };

  const [isApproved, setIsApproved] = useState<any>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);

  useEffect(() => {
    if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
      setIsApproved(
        preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse[0]?.[
          "approved"
        ]
      );
    } else if (
      preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
    ) {
      setIsApproved(
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse[0]?.[
          "approved"
        ]
      );
    }
  }, [preAuthClaim?.preAuthClaimRes]);

  const handleApprove = async () => {
    try {
      setIsApprovedInitiated(true);
      const formData = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        stage: "Claim",
        approved: true,
      };
      const res = await submitApproval(formData);
      setIsApproved(true);
      setIsApprovedInitiated(false);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsApprovedInitiated(false);
      setIsApproved(false);
    }
  };

  return (
    <div>
      {preAuthClaim?.isLoading || preAuthClaim?.isFetchingClaimData ? (
        <Loader />
      ) : (
        <PreAuthClaim
          handleFileChange={handleFileChange}
          uploadFileModal={uploadFileModal}
          selectedFile={selectedFile}
          handleCancel={handleCancel}
          handleSave={handleSaveChanges}
          handleSaveToEdgePro={handleSaveChangeToEdgePro}
          handleUploadDocument={handleUploadDocument}
          viewFile={viewFile}
          handleDeleteList={handleDeleteList}
          preAuthClaimData={preAuthClaim?.preAuthClaimRes}
          caseClaimSubmissionId={caseClaimSubmissionId}
          editedFields={preAuthClaim?.editedFields}
          onFieldChange={handleFieldChange}
          visitType={patients?.fetchBasicDetails?.visitInfoResponse?.visitType}
          uploadedDocumentUrl={preAuthClaim?.uploadedDocumentUrl}
          handleSaveChangesIhx={handleSaveChangesIhx}
          isLoading={preAuthClaim?.isSubmit}
          isEditable={isEditable}
          handleEditable={handleEditable}
          handleSetDocumentUrl={handleSetDocumentUrl}
          handleOpen={handleOpen}
          handleDownloadDocument={handleDownloadDocument}
          isDownloadingDocument={isDownloadingDocument}
          downloadingDocumentUrl={downloadingDocumentUrl}
          isSubmitted={isSubmitted}
          handleDeficiencyModal={handleDeficiencyModalOpen}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          previewDocumentUrl={previewDocumentUrl}
          setDocumentName={setDocumentName}
          handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
          portalSubmission={portalSubmission}
          allWizardSteps={preAuthClaim?.allWizardSteps}
          activeStep={preAuthClaim?.activeStep}
          handleTabsChange={handleTabsChange}
          nextStage={props?.nextStage}
          setMoveToNext={props?.setMoveToNext}
          isScreen={props?.isScreen}
          handleApprove={handleApprove}
          isApproved={isApproved}
          isApprovedInitiated={isApprovedInitiated}
          cghsProcedures={cghsProcedures}
        />
      )}
      <FilePreviewModal
        isVisible={uploadFileModal}
        onClose={handleCancel}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUploadDocument}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.uid || "no-file"}
        isLoading={preAuthClaim?.isLoading}
      />
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        type={"claim"}
      />
    </div>
  );
};

export default PreAuthClaimContainer;
